import { YmmFitmentLabelApiResponse, YmmParams } from "./types";
import { fetchYmmData } from "./fetch";
import { fetchCompatibleList } from "./fetch-compatible";

// ToDo figure out how it will work on catalyst without bypassing the cors policy
const hostname = process.env.BIGCOMMERCE_HOSTNAME ?? 'new-vision-accessories.mybigcommerce.com';

const cache = new Map<string, any>();

function makeCacheKey(params: YmmParams) {
  return JSON.stringify(params);
}

export const ymmApiClient = () => {
  return {
    getDefaultData: async () => {
      const data = await fetchYmmData({ action: 'default', domain: hostname });
      return data;
    },

    getFitmentLabelData: async (productId: string, ymmsearch: string) => {
      const data: YmmFitmentLabelApiResponse = await fetchYmmData({ action: 'getymmdesign', domain: hostname, 'product_id': productId, 'ymmsearch': ymmsearch, 'fitment_block': true });
      return data;
    },

    getOptionHtml: async ({ action = 'onchange', domain = hostname, ...params }: YmmParams) => {
      const cacheKey = makeCacheKey({ action, domain, ...params });

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const data = await fetchYmmData({ action, domain, ...params });
      cache.set(cacheKey, data);

      return data;
    },

    /** One-shot: get all dropdown HTML for a pre-selected YMM (e.g. from localStorage). tags = "yr_2026,mk_ford,md_f-150" */
    getDropdownsData: async (tags: string) => {
      const cacheKey = makeCacheKey({ action: 'get_dropdowns', domain: hostname, tags });

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const data = await fetchYmmData({ action: 'get_dropdowns', domain: hostname, tags });
      cache.set(cacheKey, data);
      return data;
    },

    getProducts: async (params: YmmParams) => {
      const cacheKey = makeCacheKey({ action: "get_products", domain: hostname, ...params });

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const data = await fetchYmmData({
        action: "get_products",
        domain: hostname,
        currentCustomerToken: "not_loggedIn",
        ...params,
      });

      cache.set(cacheKey, data);
      return data;
    },

    /** Get compatibility list HTML for a product (PDP). Returns { html, chart_fields }. */
    getCompatibleList: async (productId: number) => {
      const cacheKey = `compatible_${productId}_${hostname}`;

      if (cache.has(cacheKey)) {
        return cache.get(cacheKey);
      }

      const data = await fetchCompatibleList(productId, hostname);
      cache.set(cacheKey, data);

      return data;
    },
  }
}